(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/page-charity-payout/assets/react/charity-payout-page.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/page-charity-payout/assets/react/charity-payout-page.js');

'use strict';

const {
  useState,
  useCallback
} = React;
const {
  CharityPayoutHeader,
  CharityPayoutChartContainer,
  CharityPeppText,
  CharityCards
} = svs.lyckoplatsen.components.page_charity_payout.react.components;
const {
  CONSTANTS: {
    PAYOUT_KEYS
  }
} = svs.lyckoplatsen.components.shared_constants;
const CharityPayoutPage = () => {
  const [payoutKey, setPayoutKey] = useState(PAYOUT_KEYS.LATEST_DRAW);
  const handlePayoutKeyChange = useCallback(key => {
    setPayoutKey(key);
  }, []);
  return React.createElement("div", {
    className: "u-flex-grow-1 bg-lyckoplatsen-500"
  }, React.createElement(CharityPayoutHeader, null), React.createElement(CharityPayoutChartContainer, {
    payoutKey: payoutKey,
    handlePayoutKeyChange: handlePayoutKeyChange
  }), React.createElement(CharityPeppText, null), React.createElement(CharityCards, {
    payoutKey: payoutKey
  }));
};
Object.assign(svs.lyckoplatsen.components.page_charity_payout.react, {
  CharityPayoutPage
});

 })(window);